import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onDelete"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useRef } from 'react';
import Chip from '@mui/material/Chip';
import { ThemeProvider } from '@mui/material/styles';
import { tagTheme } from './tagStyles';
export var EmbersTag = function EmbersTag(props) {
  var onDelete = props.onDelete,
    otherProps = _objectWithoutProperties(props, _excluded);
  var chipRef = useRef(null);
  var onClickClose = function onClickClose(e) {
    chipRef.current && onDelete(chipRef.current);
  };
  var handleKeyUp = function handleKeyUp(e) {
    if (e.key === ' ' || e.key === 'Enter') onClickClose(e);
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: tagTheme
  }, /*#__PURE__*/React.createElement(Chip, _extends({
    ref: chipRef,
    onKeyUp: handleKeyUp,
    onDelete: onClickClose,
    deleteIcon: /*#__PURE__*/React.createElement("span", {
      "aria-hidden": true,
      className: "icon-close"
    })
  }, otherProps)));
};